// extracted by mini-css-extract-plugin
export default {"header-external-opt-out":"styles_header-external-opt-out__lsVd0","botonesHeader":"styles_botonesHeader__LPaOR"};